import dg_nav from "./dg-nav.vue";
import dg_footer from "./dg-footer.vue";
import dg_banner from "./dg-banner.vue";
import dg_apply from "./dg-apply.vue";


let components = [dg_nav, dg_footer, dg_banner, dg_apply];
const install = function (Vue) {
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install
}